<template>
  <div class="common-layout">
    <el-container>
      <el-header class="app-header">
        <AppHeader @lockEvent="lockEvent"/>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <AppSider class="sider"/>
        </el-aside>
        <el-container>
          <el-main>
            <router-view/>
          </el-main>
          <el-footer class="app-footer">Copyright 2024
            趣牛科技账户管理平台
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>

  <el-dialog
      v-model="centerDialogVisible"
      :close-on-press-escape="isClickClose"
      :close-on-click-modal="isClickClose"
      :show-close="isClickClose"
      width="500"
      align-center
  >
    <div style="padding: 30px 30px">
      <div style="text-align: center">
        <el-image style="width: 100px; height: 100px"
                  :src="'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'" :fit="'fill'"/>
      </div>
      <span class="lock-tips-1">密码本屏幕已锁定，需密码解锁。</span>
      <el-input v-model="password" type="password" placeholder="请输入密码解锁。" @keyup.enter="unlockAction">
        <template #append>
          <el-button type="danger" plain :icon="Lock" @click="unlockAction"> 解锁</el-button>
        </template>
      </el-input>
      <p class="lock-tips-2">
        欢迎使用密码管理工具-趣牛科技，安全又可靠。</p>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import {inject, ref} from 'vue'
import {Lock} from "@element-plus/icons-vue";
import UserService from "@/api/user";
import R from "@/utils/r";
import {ElMessage} from "element-plus";

const userService = inject('userService') as UserService;

const isClickClose = ref(false)
const centerDialogVisible = ref(false)
let password = ref('')

const lockEvent = () => {
  userService.lockScreen().then((data: any) => {
    if (R.isSuccess(data)) {
      centerDialogVisible.value = true;
      password.value = "";
    }
  });
}

const unlockAction = () => {
  if (!password.value) {
    ElMessage({
      showClose: true,
      message: "解锁密码不能为空",
      type: 'warning',
    })
    return;
  }
  const form: any = {};
  form.password = password.value;
  userService.unlockScreen(form).then((data: any) => {
    if (R.isSuccess(data)) {
      centerDialogVisible.value = false;
      password.value = "";
    }
  });
}

</script>
<style>
#app {
  height: 100%;
}

.common-layout, .el-container {
  height: 100%;
  border-top: solid 1px var(--el-menu-border-color);
}

.common-layout .app-header {
  --el-header-padding: 0 0 !important;
}

.common-layout .app-footer {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  text-align: center
}

.common-layout .sider {
  height: 100%;
}

.el-main {
  background: #f6f8f9;
}

.lock-tips-1 {
  display: block;
  text-align: center;
  margin: 30px 0;
  font-size: 14px;
}

.lock-tips-2 {
  text-align: center;
  margin-bottom: 0;
  margin-top: 30px;
  font-size: 13px;
  color: orange;
}

</style>
